// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.add__epos__item {
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
}
.add__epos__item .epos__item {
  min-height: 72vh;
  width: 100vw;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
}
.add__epos__item .epos__item .back_btn {
  position: absolute;
  top: 10px;
  left: 10px;
}
.add__epos__item .epos__item .epos__search__sql {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: relative;
}
.add__epos__item .epos__item .epos__search__sql input[type=number] {
  border: none;
  height: 5vh;
  border-radius: 0.5rem;
  padding: 0 10px;
  position: relative;
  outline: none;
}
.add__epos__item .epos__item .epos__search__sql input[type=number]::placeholder {
  color: #4d4d4d;
}
.add__epos__item .epos__item .epos__search__sql input::-webkit-outer-spin-button,
.add__epos__item .epos__item .epos__search__sql input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.add__epos__item .epos__item .epos__search__sql .search_btn {
  position: absolute;
  right: 0;
  border-radius: 1rem;
  width: 2.75vw;
  min-width: 2vw;
  height: 4vh;
  min-height: 2vh;
  margin-right: 5px;
}
.add__epos__item .epos__item .epos__no__barcode {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.add__epos__item .epos__item .epos__no__barcode label {
  color: #4d4d4d;
  margin-top: 12%;
}
.add__epos__item .epos__item form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: #fff;
  border-radius: 1rem;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  width: 25%;
  padding: 2%;
  margin-top: 2%;
}
.add__epos__item .epos__item form label {
  color: #4d4d4d;
}
.add__epos__item .epos__item form label span {
  color: #d90d1e;
}
.add__epos__item .epos__item form input[type=text],
.add__epos__item .epos__item form select {
  margin-bottom: 2%;
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
  width: 95%;
  background-color: #fff;
}
.add__epos__item .epos__item form input[type=submit] {
  margin: 1% auto;
  align-items: center;
  appearance: button;
  background-color: #0276ff;
  border-radius: 0.5rem;
  width: 30%;
  margin: auto;
  border-style: none;
  box-shadow: rgba(255, 255, 255, 0.26) 0 1px 2px inset;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  font-family: "RM Neue", sans-serif;
  font-size: 1rem;
  line-height: 1.15;
  padding: 4%;
  text-align: center;
  text-transform: none;
  transition: color 0.13s ease-in-out, background 0.13s ease-in-out, opacity 0.13s ease-in-out, box-shadow 0.13s ease-in-out;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}
.add__epos__item .epos__item form input[type=submit]:active {
  background-color: #006ae8;
}
.add__epos__item .epos__item form input[type=submit]:hover {
  background-color: #1c84ff;
}
.add__epos__item .epos__item form #stock {
  color: #d90d1e;
  display: none;
}
.add__epos__item .epos__item form #order__code {
  color: #d90d1e;
  display: none;
}
.add__epos__item .epos__item .svg {
  width: 100px;
  display: block;
  margin: 40px auto 0;
}
.add__epos__item .epos__item .svg .path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.add__epos__item .epos__item .svg .path.circle {
  animation: dash 1s ease-in-out;
}
.add__epos__item .epos__item .svg .path.check {
  stroke-dashoffset: -100;
  animation: dash-check 1s 0.35s ease-in-out forwards;
}
.add__epos__item .epos__item .svg .path.line {
  stroke-dashoffset: 1000;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}
.add__epos__item .epos__item .shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  color: #d90d1e;
}
.add__epos__item .epos__item .shake label {
  color: #d90d1e;
}
@media (max-width: 600px) {
  .add__epos__item .epos__item {
    min-height: 80vh;
  }
  .add__epos__item .epos__item .epos__search {
    justify-content: space-between;
    align-items: center;
  }
  .add__epos__item .epos__item .epos__no__barcode {
    display: none;
  }
  .add__epos__item .epos__item form {
    width: 80%;
  }
  .add__epos__item .epos__item form input[type=submit] {
    width: 37%;
  }
}
@media (min-width: 768px) and (max-width: 900px) {
  .add__epos__item .epos__item {
    min-height: 78.6vh;
  }
  .add__epos__item .epos__item .epos__search {
    justify-content: center;
    align-items: center;
  }
  .add__epos__item .epos__item form {
    width: 60%;
  }
  .add__epos__item .epos__item form input[type=submit] {
    width: 30%;
  }
}
@media (min-width: 901px) and (max-width: 1199px) {
  .add__epos__item .epos__item {
    min-height: 75vh;
  }
  .add__epos__item .epos__item .epos__search {
    justify-content: center;
    align-items: center;
  }
  .add__epos__item .epos__item form {
    width: 80%;
  }
  .add__epos__item .epos__item form input[type=submit] {
    width: 20%;
  }
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
.modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.modal .modal__row {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
}
.modal label {
  color: #4d4d4d;
}
.modal label span {
  color: #d90d1e;
}
.modal input[type=text],
.modal select {
  margin-bottom: 2%;
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
  width: 95%;
  background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/managerZone/epos/epos.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAIJ;AAHI;EACI,gBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAKR;AAHQ;EACI,kBAAA;EACA,SAAA;EACA,UAAA;AAKZ;AAHQ;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;AAKZ;AAJY;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;AAMhB;AALgB;EACI,cDlCR;ACyCZ;AAJY;;EAEI,wBAAA;EACA,SAAA;AAMhB;AAHY;EACI,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AAKhB;AAFQ;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAIZ;AAHY;EACI,cD9DJ;EC+DI,eAAA;AAKhB;AAFQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;ED/CR,0CAAA;ECiDQ,UAAA;EACA,WAAA;EACA,cAAA;AAIZ;AAHY;EACI,cD9EJ;ACmFZ;AAJgB;EACI,cAAA;AAMpB;AAHY;;EAEI,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,sBAAA;AAKhB;AAHY;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,qDAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,0HAAA;EAGA,iBAAA;EACA,yBAAA;EACA,0BAAA;AAGhB;AAFgB;EACI,yBAAA;AAIpB;AAFgB;EACI,yBAAA;AAIpB;AADY;EACI,cAAA;EACA,aAAA;AAGhB;AADY;EACI,cAAA;EACA,aAAA;AAGhB;AAAQ;EACI,YAAA;EACA,cAAA;EACA,mBAAA;AAEZ;AADY;EACI,sBAAA;EACA,oBAAA;AAGhB;AAFgB;EAEI,8BAAA;AAIpB;AAFgB;EACI,uBAAA;EAEA,mDAAA;AAIpB;AAFgB;EACI,uBAAA;EAEA,+CAAA;AAIpB;AAAQ;EACI,gEAAA;EACA,+BAAA;EACA,2BAAA;EACA,mBAAA;EAEA,cAAA;AACZ;AAAY;EACI,cAAA;AAEhB;AAEQ;EApKJ;IAqKQ,gBAAA;EACV;EAAU;IACI,8BAAA;IACA,mBAAA;EAEd;EAAU;IACI,aAAA;EAEd;EAAU;IACI,UAAA;EAEd;EADc;IACI,UAAA;EAGlB;AACF;AAAQ;EApLJ;IAqLQ,kBAAA;EAGV;EAFU;IACI,uBAAA;IACA,mBAAA;EAId;EAFU;IACI,UAAA;EAId;EAHc;IACI,UAAA;EAKlB;AACF;AAFQ;EAjMJ;IAkMQ,gBAAA;EAKV;EAJU;IACI,uBAAA;IACA,mBAAA;EAMd;EAJU;IACI,UAAA;EAMd;EALc;IACI,UAAA;EAOlB;AACF;;AADA;EACI;IAEI,kCAAA;EAGN;EAAE;IAEI,iCAAA;EACN;EAEE;IAGI,kCAAA;EAFN;EAKE;IAEI,iCAAA;EAJN;AACF;AAgBA;EACI;IACI,uBAAA;EANN;EAQE;IACI,oBAAA;EANN;AACF;AAkBA;EACI;IACI,uBAAA;EARN;EAUE;IACI,sBAAA;EARN;AACF;AAWA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AATJ;AAUI;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,WAAA;AARR;AAUI;EACI,cD9RI;ACsRZ;AASQ;EACI,cAAA;AAPZ;AAUI;;EAEI,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,sBAAA;AARR","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../../variables.scss\";\n\n.add__epos__item {\n    max-width: 100vw;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    overflow-x: hidden;\n    .epos__item {\n        min-height: 72vh;\n        width: 100vw;\n        margin: auto;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: flex-start;\n        position: relative;\n\n        .back_btn {\n            position: absolute;\n            top: 10px;\n            left: 10px;\n        }\n        .epos__search__sql {\n            display: flex;\n            justify-content: space-evenly;\n            align-items: center;\n            position: relative;\n            input[type=\"number\"] {\n                border: none;\n                height: 5vh;\n                border-radius: 0.5rem;\n                padding: 0 10px;\n                position: relative;\n                outline: none;\n                &::placeholder {\n                    color: $fontColor;\n                }\n            }\n            input::-webkit-outer-spin-button,\n            input::-webkit-inner-spin-button {\n                -webkit-appearance: none;\n                margin: 0;\n            }\n\n            .search_btn {\n                position: absolute;\n                right: 0;\n                border-radius: 1rem;\n                width: 2.75vw;\n                min-width: 2vw;\n                height: 4vh;\n                min-height: 2vh;\n                margin-right: 5px;\n            }\n        }\n        .epos__no__barcode {\n            position: absolute;\n            bottom: 0;\n            right: 0;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            label {\n                color: $fontColor;\n                margin-top: 12%;\n            }\n        }\n        form {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            justify-content: flex-start;\n            background-color: #fff;\n            border-radius: 1rem;\n            @include shadow;\n            width: 25%;\n            padding: 2%;\n            margin-top: 2%;\n            label {\n                color: $fontColor;\n                span {\n                    color: #d90d1e;\n                }\n            }\n            input[type=\"text\"],\n            select {\n                margin-bottom: 2%;\n                border: 1px solid $nitroDark;\n                border-radius: 0.5rem;\n                width: 95%;\n                background-color: #fff;\n            }\n            input[type=\"submit\"] {\n                margin: 1% auto;\n                align-items: center;\n                appearance: button;\n                background-color: #0276ff;\n                border-radius: 0.5rem;\n                width: 30%;\n                margin: auto;\n                border-style: none;\n                box-shadow: rgba(255, 255, 255, 0.26) 0 1px 2px inset;\n                box-sizing: border-box;\n                color: #fff;\n                cursor: pointer;\n                display: flex;\n                flex-direction: row;\n                flex-shrink: 0;\n                font-family: \"RM Neue\", sans-serif;\n                font-size: 1rem;\n                line-height: 1.15;\n                padding: 4%;\n                text-align: center;\n                text-transform: none;\n                transition: color 0.13s ease-in-out,\n                    background 0.13s ease-in-out, opacity 0.13s ease-in-out,\n                    box-shadow 0.13s ease-in-out;\n                user-select: none;\n                -webkit-user-select: none;\n                touch-action: manipulation;\n                &:active {\n                    background-color: #006ae8;\n                }\n                &:hover {\n                    background-color: #1c84ff;\n                }\n            }\n            #stock {\n                color: #d90d1e;\n                display: none;\n            }\n            #order__code {\n                color: #d90d1e;\n                display: none;\n            }\n        }\n        .svg {\n            width: 100px;\n            display: block;\n            margin: 40px auto 0;\n            .path {\n                stroke-dasharray: 1000;\n                stroke-dashoffset: 0;\n                &.circle {\n                    -webkit-animation: dash 1s ease-in-out;\n                    animation: dash 1s ease-in-out;\n                }\n                &.check {\n                    stroke-dashoffset: -100;\n                    -webkit-animation: dash-check 1s 0.35s ease-in-out forwards;\n                    animation: dash-check 1s 0.35s ease-in-out forwards;\n                }\n                &.line {\n                    stroke-dashoffset: 1000;\n                    -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;\n                    animation: dash 0.9s 0.35s ease-in-out forwards;\n                }\n            }\n        }\n        .shake {\n            animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n            transform: translate3d(0, 0, 0);\n            backface-visibility: hidden;\n            perspective: 1000px;\n            // background-color: #D90D1E;\n            color: #d90d1e;\n            label {\n                color: #d90d1e;\n                // color:#fff;\n            }\n        }\n        @media (max-width: $mobile) {\n            min-height: 80vh;\n            .epos__search {\n                justify-content: space-between;\n                align-items: center;\n            }\n            .epos__no__barcode {\n                display: none;\n            }\n            form {\n                width: 80%;\n                input[type=\"submit\"] {\n                    width: 37%;\n                }\n            }\n        }\n        @media (min-width: $tablet) and (max-width: $laptop) {\n            min-height: 78.6vh;\n            .epos__search {\n                justify-content: center;\n                align-items: center;\n            }\n            form {\n                width: 60%;\n                input[type=\"submit\"] {\n                    width: 30%;\n                }\n            }\n        }\n        @media (min-width: 901px) and (max-width: 1199px) {\n            min-height: 75vh;\n            .epos__search {\n                justify-content: center;\n                align-items: center;\n            }\n            form {\n                width: 80%;\n                input[type=\"submit\"] {\n                    width: 20%;\n                }\n            }\n        }\n    }\n}\n\n@keyframes shake {\n    10%,\n    90% {\n        transform: translate3d(-1px, 0, 0);\n    }\n\n    20%,\n    80% {\n        transform: translate3d(2px, 0, 0);\n    }\n\n    30%,\n    50%,\n    70% {\n        transform: translate3d(-4px, 0, 0);\n    }\n\n    40%,\n    60% {\n        transform: translate3d(4px, 0, 0);\n    }\n}\n\n@-webkit-keyframes dash {\n    0% {\n        stroke-dashoffset: 1000;\n    }\n    100% {\n        stroke-dashoffset: 0;\n    }\n}\n\n@keyframes dash {\n    0% {\n        stroke-dashoffset: 1000;\n    }\n    100% {\n        stroke-dashoffset: 0;\n    }\n}\n\n@-webkit-keyframes dash-check {\n    0% {\n        stroke-dashoffset: -100;\n    }\n    100% {\n        stroke-dashoffset: 900;\n    }\n}\n\n@keyframes dash-check {\n    0% {\n        stroke-dashoffset: -100;\n    }\n    100% {\n        stroke-dashoffset: 900;\n    }\n}\n\n.modal {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    .modal__row {\n        display: flex;\n        justify-content: space-evenly;\n        align-items: center;\n        width: 100%;\n    }\n    label {\n        color: $fontColor;\n        span {\n            color: #d90d1e;\n        }\n    }\n    input[type=\"text\"],\n    select {\n        margin-bottom: 2%;\n        border: 1px solid $nitroDark;\n        border-radius: 0.5rem;\n        width: 95%;\n        background-color: #fff;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
